export default __webpack_public_path__ + "static/media/person-icon.0f1c33b3.svg";